import React, { useEffect, useState } from 'react'
import Image from 'next/image'
import { RequestProvider } from '../../../../context/RequestContext'
import { s3Static } from '../../../../utils/constants'
import { Services } from '../../service/Services'
import { openModal } from '../../../../service/modal-service'
import { motion, useMotionValueEvent, useScroll } from 'framer-motion'
import { HiSparkles } from 'react-icons/hi'
import { MdKeyboardDoubleArrowRight } from 'react-icons/md'
import { FreeConsultationGuide } from './FreeConsultationGuide'

export const PersonalTrainerRequestForm = (props) => {
    const requestCategorySettings = props.requestCategorySettings
    const requestType = "Fitness Trainer"
    
    const [ requestForm, setRequestForm ] = useState(false)
    const [ isShowConsultationDetails, setIsShowConsultationDetails ] = useState(false)
    const [ isShowBottomButtons, setIsShowBottomButtons ] = useState(false)

    useEffect(() => {
        // setRequestForm(true)
        openModal(setRequestForm)
    }, [])

    const openRequestForm = () => {
        window.scrollTo({ top: 0 });
        // setRequestForm(true)
        openModal(setRequestForm)
    }

    const { scrollY } = useScroll()

    useMotionValueEvent(scrollY, "change", (latest) => {
        if(latest > 1000){
            if(!isShowBottomButtons){
                setIsShowBottomButtons(true)
            }
        } else {
            if(isShowBottomButtons){
                setIsShowBottomButtons(false)
            }
        }
    })

  return (
    <>
        <div id="fitness-trainer" className="-mt-14 relative overflow-hidden transition-height duration-200" style={{height : "720px"}}>            
            <div className="h-full w-full relative">
                <Image className='bg-linear-to-br from-slate-800 to-orange-300'
                    src={s3Static + "personal-trainer/personal-trainer.jpg"}
                    fill
                    style={{objectFit: 'cover'}}
                    alt='Freelance Personal Trainer Singapore'
                    priority="false"
                    quality={100}
                    />
                {/* Dark overlay for dark theme consistency */}
                <div className="absolute inset-0 bg-linear-to-t from-slate-900/90 via-slate-900/40 to-slate-900/20" />
            </div>        
            <div id="campaign" className='absolute top-1/2 -translate-y-1/2 w-full'>
                {requestForm ?
                    <RequestProvider>
                        <Services requestType={requestType} requestCategorySettings={requestCategorySettings} setRequestForm={setRequestForm}/>
                    </RequestProvider> 
                :
                    <div className='bg-slate-900/70 backdrop-blur-md border border-white/10 rounded-4xl max-w-lg sm:max-w-4xl mx-auto px-4 py-10 space-y-5 text-center'>
                        {/* Mesh gradient accent */}
                        <div className="absolute top-0 left-1/4 w-48 h-48 bg-orange-500/20 rounded-full blur-3xl -translate-y-1/2" />
                        <div className="absolute bottom-0 right-1/4 w-40 h-40 bg-amber-400/15 rounded-full blur-3xl translate-y-1/2" />
                        
                        <header className='space-y-3 relative'>
                            <h3 className='text-lg text-white/80 px-3 leading-relaxed font-medium'>
                                Affordable personal training at home, condo gym & outdoor
                            </h3>
                        </header>
                        <div className='relative py-6 px-2 space-y-3 sm:flex sm:items-center sm:justify-center sm:space-x-5 sm:space-y-0'>
                            <motion.button
                                type="button"
                                role="button"
                                aria-label="Book free personal training trial"
                                title="Book free personal training trial"
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.97 }}
                                onClick={() => quickBookPT("Fitness Trainer", "Personal training free consultation")}
                                className="flex items-center justify-center w-full sm:w-auto text-lg sm:text-xl bg-linear-to-r from-orange-500 to-amber-400 hover:from-orange-600 hover:to-amber-500 text-white font-bold px-8 py-4 rounded-full shadow-lg shadow-orange-500/30 transition-all duration-300"
                            >
                                <HiSparkles className='mr-2 text-2xl'/> Free Consultation
                            </motion.button>
                            
                            <div className='text-center pt-2'>
                                <button
                                    type="button"
                                    aria-label="View free consultation details"
                                    className='flex items-center justify-center w-full text-white/60 hover:text-white font-medium transition-colors'
                                    onClick={() => openModal(setIsShowConsultationDetails)}
                                >
                                    <MdKeyboardDoubleArrowRight className='text-2xl animate-pulse text-orange-400' />
                                    <span className='text-sm'>What&apos;s Included?</span>
                                </button>
                            </div>
                        </div>
                    </div>
                } 
            </div>
            <motion.div className='fixed bottom-1 w-full text-center z-10 flex justify-center' 
                animate={isShowBottomButtons ? {y: "0px"} : {y: "80px"}}
                transition={{type: "spring", stiffness: 100, ease: "easeInOut", duration: 0.3}}
            >
                <button 
                type="button" 
                aria-label='Claim a Personal Trainer trial session'
                className='text-white py-3 px-8 rounded-full bg-linear-to-tr from-orange-600 to-amber-400 block font-bold text-sm' 
                onClick={() => openRequestForm()}>
                    Claim Free Consultation
                </button>
            </motion.div>
        </div>
        <FreeConsultationGuide 
            isOpen={isShowConsultationDetails} 
            setIsShowConsultationDetails={setIsShowConsultationDetails} 
            quickBookPT={openRequestForm} 
        />
    </>
  )
}
